<div class="d-flex flex-column h-100">
  <div class="modal-header">
    <h1 class="modal-title">Activity Log</h1>
    <span (click)="activeModal.dismiss('Cross click')" role="button">
      <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
    </span>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-column h-100">
      <p-iconfield class="d-block w-100" iconPosition="left">
        <p-inputicon class="pi pi-search" />
        <input
          type="text"
          pInputText
          class="w-100"
          [ngModel]="activityLogSearch()"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Search Logs"
        />
      </p-iconfield>
      <div class="d-flex gap-3 mt-3 mb-3">
        <div class="col">
          <p-datepicker
            styleClass="w-100"
            [ngModel]="activityLogFromDate()"
            (ngModelChange)="onFromDateChange($event)"
            [showIcon]="true"
            [maxDate]="activityLogToDate()"
            dateFormat="mm/dd/yy"
            placeholder="From Date"
            [readonlyInput]="true"
          ></p-datepicker>
        </div>
        <div class="col">
          <p-datepicker
            styleClass="w-100"
            [ngModel]="activityLogToDate()"
            (ngModelChange)="onToDateChange($event)"
            [showIcon]="true"
            [minDate]="activityLogFromDate()"
            dateFormat="mm/dd/yy"
            placeholder="To Date"
            [readonlyInput]="true"
          ></p-datepicker>
        </div>
      </div>
      <hr class="text-gray-300 mt-0" />
      <div class="flex-fill overflow-hidden position-relative">
        @if (isLoadingActivityLogs()) {
          <div class="loading-overlay">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        } @else {
          <div class="table-outer table-modal h-15">
            <div class="table-responsive h-100">
              <p-table
                [className]="'table-prime'"
                [value]="activityLogs()"
                [scrollable]="true"
                scrollHeight="flex"
                [virtualScroll]="true"
                [virtualScrollItemSize]="58"
              >
                <ng-template #header>
                  <tr>
                    <th>File</th>
                    <th>Status</th>
                    <th>User</th>
                    <th>Date</th>
                  </tr>
                </ng-template>
                <ng-template #body let-activity>
                  <tr>
                    <td>
                      <span class="d-block lh-sm fs-14">
                        <svg-icon [name]="getActivityIcon(activity?.fileSystemName)" class="svg-24 me-1"></svg-icon>
                        {{ activity?.fileSystemName }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="px-2 py-1 border-0 alert fw-500 fs-14"
                        [ngClass]="activityStatusClass(activity?.activity)"
                      >
                        {{ formatActivityLabel(activity?.activity) }}
                      </span>
                    </td>
                    <td>
                      <div class="gap-1 card-users flex-nowrap">
                        <ul class="list-unstyled">
                          <li>
                            <span class="user-30"
                              >{{ activity?.userName?.split(' ')[0] | FirstCapital
                              }}{{ activity?.userName?.split(' ')[1] | FirstCapital }}</span
                            >
                          </li>
                        </ul>
                        <span>
                          {{ activity?.userName?.split(' ')[0] | titlecase }}
                          {{ activity?.userName?.split(' ')[1] | titlecase }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex flex-column">
                        <span class="fs-14 text-secondary d-block">{{ activity?.date | dateFormat }}</span>
                        <span class="text-gray-400 fs-12 d-block">{{ activity?.date | date }}</span>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="4" class="text-center">No Logs Found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Close</button>
  </div>
</div>
